import { LocationProvider, Router, Route, ErrorBoundary } from "preact-iso";
import { useEffect } from "preact/hooks";
import { lazy } from "preact-iso";
import { Toasts } from "./components/Toasts.js";
import { ProtectedRoute } from "./components/ProtectedRoute.js";
import { restoreAuth } from "./store/auth.js";
import { setupTokenRefresh } from "./auth/token-refresh.js";
import Home from "./pages/Home.js";
import Login from "./pages/Login.js";
import Callback from "./pages/Callback.js";
import Docs from "./pages/Docs.js";
import Blog from "./pages/Blog.js";
import BlogLaunch from "./pages/BlogLaunch.js";
import BlogN8nPayloads from "./pages/BlogN8nPayloads.js";
import Privacy from "./pages/Privacy.js";
import Terms from "./pages/Terms.js";
import About from "./pages/About.js";
import Security from "./pages/Security.js";
import Guides from "./pages/Guides.js";
import NotFound from "./pages/NotFound.js";

const Dashboard = lazy(() => import("./pages/Dashboard.js"));
const Endpoints = lazy(() => import("./pages/Endpoints.js"));
const EndpointDetail = lazy(() => import("./pages/EndpointDetail.js"));
const ApiKeys = lazy(() => import("./pages/ApiKeys.js"));
const Settings = lazy(() => import("./pages/Settings.js"));
const Usage = lazy(() => import("./pages/Usage.js"));
const DpaLegal = lazy(() => import("./pages/DpaLegal.js"));

export function App() {
  useEffect(() => {
    restoreAuth();
    const dispose = setupTokenRefresh();
    return dispose;
  }, []);

  return (
    <LocationProvider>
      <ErrorBoundary>
        <Router>
          <Route path="/" component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/callback" component={Callback} />
          <Route path="/docs" component={Docs} />
          <Route path="/blog" component={Blog} />
          <Route
            path="/blog/webhookstorage-is-live"
            component={BlogLaunch}
          />
          <Route
            path="/blog/n8n-large-payloads"
            component={BlogN8nPayloads}
          />
          <Route path="/privacy" component={Privacy} />
          <Route path="/terms" component={Terms} />
          <Route path="/about" component={About} />
          <Route path="/security" component={Security} />
          <Route path="/guides" component={Guides} />
          <Route
            path="/dashboard"
            component={() => (
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            )}
          />
          <Route
            path="/endpoints"
            component={() => (
              <ProtectedRoute><Endpoints /></ProtectedRoute>
            )}
          />
          <Route
            path="/endpoints/:id"
            component={() => (
              <ProtectedRoute><EndpointDetail /></ProtectedRoute>
            )}
          />
          <Route
            path="/keys"
            component={() => (
              <ProtectedRoute><ApiKeys /></ProtectedRoute>
            )}
          />
          <Route
            path="/settings"
            component={() => (
              <ProtectedRoute><Settings /></ProtectedRoute>
            )}
          />
          <Route
            path="/settings/billing"
            component={() => (
              <ProtectedRoute><Usage /></ProtectedRoute>
            )}
          />
          <Route
            path="/usage"
            component={() => (
              <ProtectedRoute><Usage /></ProtectedRoute>
            )}
          />
          <Route
            path="/legal"
            component={() => (
              <ProtectedRoute><DpaLegal /></ProtectedRoute>
            )}
          />
          <Route default component={NotFound} />
        </Router>
        <Toasts />
      </ErrorBoundary>
    </LocationProvider>
  );
}
